import { render, staticRenderFns } from "./2-AdditionalQuestions.vue?vue&type=template&id=0bb3cab5&scoped=true"
import script from "./2-AdditionalQuestions.vue?vue&type=script&lang=js"
export * from "./2-AdditionalQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb3cab5",
  null
  
)

export default component.exports